import script from "./RegistrationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationModal.vue?vue&type=style&index=0&id=528ea28d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528ea28d"]])

export default __exports__